export const colorDanger100 = "#ffebeb";
export const colorDanger200 = "#ffc7cb";
export const colorDanger300 = "#ffa8ad";
export const colorDanger400 = "#ff8a90";
export const colorDanger500 = "#ff6b73";
export const colorDanger600 = "#ff2934";
export const colorDanger700 = "#e5000c";
export const colorDanger800 = "#a30009";
export const colorDanger900 = "#660006";
export const colorGreyscale100 = "#ffffff";
export const colorGreyscale200 = "#f9fafc";
export const colorGreyscale300 = "#f1f4f8";
export const colorGreyscale400 = "#dee5ed";
export const colorGreyscale500 = "#abbdd1";
export const colorGreyscale600 = "#587698";
export const colorGreyscale700 = "#37495c";
export const colorGreyscale800 = "#25303c";
export const colorGreyscale900 = "#0d0f12";
export const colorPrimary100 = "#ebf5ff";
export const colorPrimary200 = "#d6eaff";
export const colorPrimary300 = "#7ab6ff";
export const colorPrimary400 = "#3d91ff";
export const colorPrimary500 = "#0d73ff";
export const colorPrimary600 = "#0958d7";
export const colorPrimary700 = "#0e43a4";
export const colorPrimary800 = "#0e3681";
export const colorPrimary900 = "#0d3073";
export const colorSecondary100 = "#ffebeb";
export const colorSecondary200 = "#ffc7cb";
export const colorSecondary300 = "#ffa8ad";
export const colorSecondary400 = "#ff8a90";
export const colorSecondary500 = "#ff6b73";
export const colorSecondary600 = "#ff2934";
export const colorSecondary700 = "#e5000c";
export const colorSecondary800 = "#a30009";
export const colorSecondary900 = "#660006";
export const colorSuccess100 = "#f2fffa";
export const colorSuccess200 = "#ddf7ee";
export const colorSuccess300 = "#91f6d2";
export const colorSuccess400 = "#00e4a9";
export const colorSuccess500 = "#00c996";
export const colorSuccess600 = "#00ae82";
export const colorSuccess700 = "#00946e";
export const colorSuccess800 = "#00795a";
export const colorSuccess900 = "#004332";
export const colorWarning100 = "#fffaf2";
export const colorWarning200 = "#fee6bd";
export const colorWarning300 = "#fcd289";
export const colorWarning400 = "#fbb43a";
export const colorWarning500 = "#faa719";
export const colorWarning600 = "#df8f05";
export const colorWarning700 = "#c57e04";
export const colorWarning800 = "#ab6d04";
export const colorWarning900 = "#5c3b02";
export const fontFaceLabGrotesque400NormalWoff = "https://static.airhelp.com/fonts/LabGrotesque-Regular.woff";
export const fontFaceLabGrotesque400NormalWoff2 = "https://static.airhelp.com/fonts/LabGrotesque-Regular.woff2";
export const fontFaceLabGrotesque500NormalWoff = "https://static.airhelp.com/fonts/LabGrotesque-Medium.woff";
export const fontFaceLabGrotesque500NormalWoff2 = "https://static.airhelp.com/fonts/LabGrotesque-Medium.woff2";
export const fontFaceLabGrotesque700NormalWoff = "https://static.airhelp.com/fonts/LabGrotesque-Bold.woff";
export const fontFaceLabGrotesque700NormalWoff2 = "https://static.airhelp.com/fonts/LabGrotesque-Bold.woff2";
export const fontFaceNotoSansSc400NormalWoff2 = "https://static.airhelp.com/fonts/NotoSans-SC-Regular.woff2";
export const fontFaceNotoSansSc500NormalWoff2 = "https://static.airhelp.com/fonts/NotoSans-SC-Medium.woff2";
export const fontFaceNotoSansSc700NormalWoff2 = "https://static.airhelp.com/fonts/NotoSans-SC-Bold.woff2";
export const fontFaceNotoSansArabic400NormalWoff2 = "https://static.airhelp.com/fonts/NotoSans-Arabic-Regular.woff2";
export const fontFaceNotoSansArabic500NormalWoff2 = "https://static.airhelp.com/fonts/NotoSans-Arabic-Medium.woff2";
export const fontFaceNotoSansArabic700NormalWoff2 = "https://static.airhelp.com/fonts/NotoSans-Arabic-Bold.woff2";
export const fontFamilyMain = "'Lab Grotesque', sans-serif";
export const fontFamilyZhCn = "'Noto Sans SC', sans-serif";
export const fontFamilyAr = "'Noto Sans Aabic', sans-serif";
export const fontFamilyFraktion = "'PP Fraktion Sans', sans-serif";
export const fontFamilyFraktion400NormalOtf = "https://img.airhelp.com/fonts/PPFraktionSans-Light.otf";
export const fontFamilyFraktion700NormalOtf = "https://img.airhelp.com/fonts/PPFraktionSans-Bold.otf";
export const fontSizeXs = "0.75rem";
export const fontSizeSm = "0.875rem";
export const fontSizeMd = "1rem";
export const fontSizeLg = "1.125rem";
export const fontSizeXl = "1.375rem";
export const fontSize2xl = "1.5rem";
export const fontSize3xl = "2rem";
export const fontSize4xl = "2.5rem";
export const fontSize5xl = "3rem";
export const fontWeightNormal = 400;
export const fontWeightMedium = 500;
export const fontWeightBold = 700;
export const spinnerBorderWidthXs = "2px";
export const spinnerBorderWidthSm = "3px";
export const spinnerBorderWidthMd = "4px";
export const spinnerBorderWidthLg = "6px";
export const borderWidthSm = "1px";
export const borderRadiusSm = "4px";
export const borderRadiusMd = "8px";
export const borderRadiusLg = "12px";
export const borderRadiusXl = "16px";
export const borderRadius2xl = "20px";
export const borderRadius3xl = "24px";
export const breakpointMobile = "320px";
export const breakpointTablet = "768px";
export const breakpointDesktop = "992px";
export const breakpointLargedesktop = "1200px";
export const heightButtonXs = "32px";
export const heightButtonSm = "40px";
export const heightButtonMd = "48px";
export const heightButtonLg = "56px";
export const heightButtonXl = "72px";
export const heightButtonIconSm = "16px";
export const heightButtonIconMd = "20px";
export const heightButtonIconLg = "24px";
export const heightButtonSpinnerXs = "16px";
export const heightButtonSpinnerSm = "20px";
export const heightButtonSpinnerMd = "24px";
export const heightButtonSpinnerLg = "28px";
export const heightButtonSpinnerXl = "32px";
export const heightSpinnerMd = "48px";
export const heightSpinnerLg = "64px";
export const lineHeightNone = 1;
export const lineHeightShort = 1.2;
export const lineHeightBase = 1.5;
export const shadowsNone = "none";
export const shadowsBase = "0px 1px 4px rgba(30, 41, 54, 0.2)";
export const shadowsMd = "0px 4px 12px rgba(30, 41, 54, 0.16)";
export const shadowsLg = "0px 8px 32px rgba(30, 41, 54, 0.12)";
export const shadowsAlt = "4px 8px 26px rgba(182, 190, 209, 0.25)";
export const spacingAuto = "auto";
export const spacing1x = "4px";
export const spacing2x = "8px";
export const spacing3x = "12px";
export const spacing4x = "16px";
export const spacing5x = "20px";
export const spacing6x = "24px";
export const spacing8x = "32px";
export const spacing10x = "40px";
export const spacing12x = "48px";
export const spacing16x = "64px";
export const spacing24x = "96px";
export const spacing32x = "128px";
